import { ReactElement } from 'react';

export function PaymentCoinIcon(): ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
    >
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M10 6c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8v8m0-8c1.11 0 2.08.402 2.599 1M10 6V5m0 9v1m0-1c-1.11 0-2.08-.402-2.599-1M19 10a9 9 0 11-18 0 9 9 0 0118 0z"
      ></path>
    </svg>
  );
}
